import { db } from '@/lib/firebase';
import { collection, addDoc, query, where, orderBy, getDocs, doc, deleteDoc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';

export interface PromptHistory {
  id?: string;
  description: string;
  additionalContext?: string;
  generatedPrompts: string[];
  timestamp: Date;
  tokensUsed: number;
  favorite: boolean;
  tags?: string[];
}

export const promptHistoryService = {
  async savePrompt(userId: string, promptData: Omit<PromptHistory, 'id' | 'timestamp'>): Promise<string> {
    const promptRef = collection(db, 'users', userId, 'prompts');
    const docRef = await addDoc(promptRef, {
      ...promptData,
      timestamp: new Date(),
    });
    return docRef.id;
  },

  async getPromptHistory(userId: string): Promise<PromptHistory[]> {
    const promptRef = collection(db, 'users', userId, 'prompts');
    const q = query(promptRef, orderBy('timestamp', 'desc'));
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as PromptHistory[];
  },

  async getFavoritePrompts(userId: string): Promise<PromptHistory[]> {
    const promptRef = collection(db, 'users', userId, 'prompts');
    const q = query(
      promptRef, 
      where('favorite', '==', true),
      orderBy('timestamp', 'desc')
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as PromptHistory[];
  },

  async toggleFavorite(userId: string, promptId: string, favorite: boolean): Promise<void> {
    const promptRef = doc(db, 'users', userId, 'prompts', promptId);
    await updateDoc(promptRef, { favorite });
  },

  async deletePrompt(userId: string, promptId: string): Promise<void> {
    const promptRef = doc(db, 'users', userId, 'prompts', promptId);
    await deleteDoc(promptRef);
  },

  async addTag(userId: string, promptId: string, tag: string): Promise<void> {
    const promptRef = doc(db, 'users', userId, 'prompts', promptId);
    await updateDoc(promptRef, {
      tags: arrayUnion(tag)
    });
  },

  async removeTag(userId: string, promptId: string, tag: string): Promise<void> {
    const promptRef = doc(db, 'users', userId, 'prompts', promptId);
    await updateDoc(promptRef, {
      tags: arrayRemove(tag)
    });
  }
}; 